import { render } from "./UserIcon.vue?vue&type=template&id=bc6d041c"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/UserIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc6d041c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc6d041c', __exports__)) {
    api.reload('bc6d041c', __exports__)
  }
  
  module.hot.accept("./UserIcon.vue?vue&type=template&id=bc6d041c", () => {
    api.rerender('bc6d041c', render)
  })

}


export default __exports__